<template>
  <div class="no-padding no-margin">
      <Table v-if="route==`/provider/employers`"></Table>
      <AddNewForm v-if="route==`/provider/employers/add-new`"></AddNewForm> 
      <SingleForm v-if="route==`/provider/employers/employer`"></SingleForm>
      <InviteForm  v-if="route==`/provider/employers/invite-employer`"></InviteForm>
  </div>
    
</template>
<script>
import Table from './EmployersTable.vue'
import SingleForm from './SingleEmployer.vue'
import AddNewForm from './AddEmployer.vue'
import InviteForm from './InviteEmployers.vue'
// getPath

export default{
  data(){
    return{
        
    }
  },
  created(){
  },
  computed:{
     route(){
        return this.$route.path;
      },
      routeParams(){
        let parsed =''
        if(this.$route.params.name){
          parsed = this.$route.params.name.replace(/ /g, '%20')
        }
        return parsed
      }
  },
  methods:{

  },
  components:{
        SingleForm,
        AddNewForm,
        Table,
        InviteForm
 
  }
}

</script>
